import { get } from './api.service';
import { URL_CHALLENGES } from '@constants/api.constants';

export const getChallenges = (merchantId: string, countryCode: string) => {
	return get(`${URL_CHALLENGES}/merchant/${merchantId}?country=${countryCode}`);
};
